var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoor3DobjectCloset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.292,
    y: 3.074,
    width: 27.417,
    height: 32.806,
    rx: 1.332,
    ry: 1.332
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.982,
    y1: 13.823,
    x2: 16.982,
    y2: 16.87
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 25.018,
    y1: 13.823,
    x2: 25.018,
    y2: 16.87
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 9.986,
    y1: 35.88,
    x2: 9.986,
    y2: 38.926
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 32.014,
    y1: 35.88,
    x2: 32.014,
    y2: 38.926
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 26.175,
    y1: 31.425,
    x2: 29.221,
    y2: 31.425
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 12.779,
    y1: 31.425,
    x2: 15.825,
    y2: 31.425
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 7.292,
    y1: 27.235,
    x2: 34.708,
    y2: 27.235
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 35.88,
    x2: 21,
    y2: 3.074
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoor3DobjectCloset);
export default __webpack_public_path__ + "static/media/indoor-3dobject_closet.995a452cd35c2a9c2510bdd5bba6b2ff.svg";
export { ForwardRef as ReactComponent };